<template>
  <nav class="fixed top-0 left-0 right-0 z-50 navbar border-b border-border shadow-lg">
    <div class="page-gutter">
      <div class="flex items-center justify-between py-4">
        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-3">
          <img src="/logo.png" alt="App to Link Logo" class="w-8 h-8 object-contain" />
          <span class="text-xl font-extrabold tracking-tight gradient-text">App to Link</span>
        </router-link>

        <!-- Mobile menu toggle -->
        <button 
          @click="mobileMenuOpen = !mobileMenuOpen"
          class="md:hidden p-2 text-text hover:text-primary-400 transition"
          aria-label="Toggle navigation"
          :aria-expanded="mobileMenuOpen"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
            <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center gap-6 text-sm text-muted">
          <router-link 
            exact
            to="/" 
            class="hover:text-text transition"
            active-class="text-primary-400 font-semibold"
          >
            Home
          </router-link>
          <router-link 
            to="/pricing" 
            class="hover:text-text transition"
            active-class="text-primary-400 font-semibold"
          >
            Pricing
          </router-link>
          <router-link 
            to="/privacy-policy" 
            class="hover:text-text transition"
            active-class="text-primary-400 font-semibold"
          >
            Privacy Policy
          </router-link>
          <router-link 
            to="/terms-of-service" 
            class="hover:text-text transition"
            active-class="text-primary-400 font-semibold"
          >
            Terms of Service
          </router-link>
          <router-link 
            to="/data-deletion" 
            class="hover:text-text transition"
            active-class="text-primary-400 font-semibold"
          >
            Data Deletion
          </router-link>
          <a 
            :href="infoMailto" 
            class="hover:text-text transition flex items-center gap-1"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            Contact
          </a>
        </div>
      </div>

      <!-- Mobile Navigation -->
      <div 
        v-if="mobileMenuOpen" 
        class="md:hidden pb-4 space-y-3 border-t border-border pt-4 mt-2"
      >
        <router-link 
          exact
          to="/" 
          @click.native="mobileMenuOpen = false"
          class="block py-2 text-muted hover:text-text transition"
          active-class="text-primary-400 font-semibold"
        >
          Home
        </router-link>
        <router-link 
          to="/pricing" 
          @click.native="mobileMenuOpen = false"
          class="block py-2 text-muted hover:text-text transition"
          active-class="text-primary-400 font-semibold"
        >
          Pricing
        </router-link>
        <router-link 
          to="/privacy-policy" 
          @click.native="mobileMenuOpen = false"
          class="block py-2 text-muted hover:text-text transition"
          active-class="text-primary-400 font-semibold"
        >
          Privacy Policy
        </router-link>
        <router-link 
          to="/terms-of-service" 
          @click.native="mobileMenuOpen = false"
          class="block py-2 text-muted hover:text-text transition"
          active-class="text-primary-400 font-semibold"
        >
          Terms of Service
        </router-link>
        <router-link 
          to="/data-deletion" 
          @click.native="mobileMenuOpen = false"
          class="block py-2 text-muted hover:text-text transition"
          active-class="text-primary-400 font-semibold"
        >
          Data Deletion
        </router-link>
        <a 
          :href="infoMailto" 
          class="block py-2 text-muted hover:text-text transition flex items-center gap-1"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          Contact
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import emailObfuscation from '@/mixins/emailObfuscation';

export default {
  name: 'AppNavbar',
  mixins: [emailObfuscation],
  data() {
    return {
      mobileMenuOpen: false
    }
  }
}
</script>
